import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Tridys, deepCopy, getKeyValue, getSubtitleKeyOfTridy, getTitleKeyOfTridy, getValueFormatSupport, getValueFromKey, isDateTime, isTimeStamp, returnDateIfStringFormatZ } from 'na-lib';
import { CommentsService } from 'src/app/service/comments.service';
import { SettingsService } from 'src/app/service/settings.service';
import { extractFilenameFromUrl } from 'na-lib';
import { Router } from '@angular/router';
import { QrCodeDialogComponent } from 'src/app/qr-code-dialog/qr-code-dialog.component';
import { environment } from 'src/environments/environment';
import { TridysService } from '../../service/tridys.service';

@Component({
    selector: 'app-reports-item-tridy-dialog',
    templateUrl: './reports-item-tridy-dialog.component.html',
    styleUrl: './reports-item-tridy-dialog.component.css',
    standalone: false
})

export class ReportsItemTridyDialogComponent {
  tridyData:any
  routerUrl:any
  idToShow:any
  finishedTasks:any=[]
  payload:any
  contextId:string
  tridyValues: Tridys
  contentType:string
  panelOpenState=false
  tridyArray:any
  tridyMap:any
  finishedTasksData:any
  resize:number;
  backToPath:any
  backToPathName:any
  allpayload:any = []
  media:any={}
  mediaData:any
  urlData:any = {}
  outgoing:any[]=[]
  incoming:any[]=[]
  allContentTypesList:any = []
  allTridysList:any
  contentTypeData:any
  payloadCard:any
  showAll:boolean

  titleKey:any
  subtitleKeys:string[]

  incomingTitleKey:any
  outgoingTitleKey:any

  titleValue:any
  incomingTitleValue:any
  outgoingTitleValue:any

  subtitleValues:any
  incomingSubtitleValues:any
  outgoingSubtitleValues:any

  fileName:any={}

  constructor(
    private dialogRef: MatDialogRef<ReportsItemTridyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private settingsService: SettingsService,
    private commentService: CommentsService,
    private tridysService:TridysService, 
    public dialog: MatDialog,
    private router:Router) { }

  async ngOnInit():Promise<void>{
    this.idToShow = this.data?.idToShow

    if(this.settingsService.settingsContentTypesWithId.length==0)
      await this.getContentTypes()
    else
      this.allContentTypesList = this.settingsService.settingsContentTypesWithId

    if(this.tridysService.allTridys$.length!=0)
      this.allTridysList = this.tridysService.allTridys$
    else
      this.tridysService.observeTridysFirestore().subscribe( results => this.allTridysList = results )
    

    this.commentService.progressSpin.emit(true)
    try{
      this.tridysService.observeTridyIdDoc(this.data.idToShow).subscribe(ref => {
        const tridy = ref.data()
        this.tridyData = tridy
        //console.log('tridyData',tridy)
  
        this.contentTypeData = this.getContentTypeDataById(this.tridyData.contentType)
        this.titleKey = this.getContentTypeFieldById(this.tridyData.contentType, 'titleKey') || false;
        this.subtitleKeys = this.getContentTypeFieldById(this.tridyData.contentType, 'subtitleKeys') || false;
  
        this.tridysService.getTridyReferences(ref.id).then(references => {
          this.incoming = references.incoming
          this.outgoing = references.outgoing
        }).catch(error => console.error('Failed to load Tridy references', error))
  
        this.tridyValues = new Tridys()
        this.tridyValues.setFromAny(this.tridyData)
        this.payload = this.tridyValues.getPayload()
  
        if(this.payload){
          const foundTitleKey = Object.keys(this.payload).find(key => key == this.titleKey)
          if(foundTitleKey)
            this.titleValue = this.payload[foundTitleKey]
  
          const foundSubtitleKeys = Array.isArray(this.subtitleKeys) ? this.subtitleKeys : Object.keys(this.payload);
          this.subtitleValues = foundSubtitleKeys.map(key => {
            const value = this.payload[key]
            if(value && (value.seconds || value.nanoseconds))
              return isDateTime(value)
            else
              return this.payload[key]
          });

          if(!this.titleValue)
          this.loadPlaceholdersInKeysTitle()
  
          this.loadPlaceholdersInKeysSubtitle()
          this.allpayload = Object.entries(this.payload)
          //console.log(this.allpayload)
  
          if(this.payload.array)
            this.tridyArray=this.payload.array
    
          if(this.payload.map)
            this.tridyMap=this.payload.map
        }
  
        if(this.tridyData && this.tridyData.media){
          this.mediaData = this.tridyData.media
  
          this.tridyData.media.forEach( med=> {
            this.media[med.key] = med.files
            if(med.files){
              med.files.forEach(async file => {
                await this.supportUrl(file.url, med.key)
                const url = this.urlData[med.key]
                const filename = extractFilenameFromUrl(url)
  
                if(file.mimeType == "image/jpeg"){
                  if(!file.filename)
                    this.fileName[med.key] = filename
                  else
                    this.fileName[med.key] = file.filename
                }
              });
            }
          })
        }
        this.contentType = this.tridyValues.contentType
        this.commentService.progressSpin.emit(false)
      })
     }catch(error){
      this.commentService.progressSpin.emit(false)
     }

     this.contextId = this.settingsService.contextId$;

     this.getFinishedTasks()

  }

  ngOnDestroy(){
    this.titleKey = undefined
    this.subtitleKeys = []
    this.subtitleValues = []
  }

  loadPlaceholdersInKeysTitle(){
    //console.log('titleKey',this.titleKey)
    if(this.titleKey){
      const placeholders = this.titleKey.match(/\$\{([^}]+)\}/g)?.map(v => v.slice(2, -1));//.matchAll(/\$\{([^}]+)\}/g)
      //console.log('placeholders', placeholders)
      this.titleValue = deepCopy(this.titleKey)

      if(placeholders){
      
        placeholders.forEach( key => {
          const valueKey = getKeyValue(this.payload, key)
          const titleValue = deepCopy(this.titleValue)
          let value = valueKey ? getValueFormatSupport(valueKey) : ''

          this.titleValue = titleValue.replaceAll(`\${${key}}`, value)
        })
      }
      const parts = this.titleKey.split(/\s+/);
      if(parts){
        const partsWithDot = parts.filter(k => k.includes(".") && !k?.match(/\$\{([^}]+)\}/g));
        partsWithDot?.forEach(part => {
          const valueKey = getKeyValue(this.payload, part)
          let value = valueKey ? getValueFormatSupport(valueKey) : ''
          this.titleValue = this.titleValue.replaceAll(part, value)
        });
      }
    }
    
  }

  loadPlaceholdersInKeysSubtitle(){
    this.subtitleValues = deepCopy(this.subtitleKeys)
    if(this.subtitleKeys){
      this.subtitleKeys?.forEach((sub, index) => {
        const placeholdersSub = sub?.match(/\$\{([^}]+)\}/g)?.map(v => v.slice(2, -1));
        if(placeholdersSub){
          placeholdersSub.forEach(key => {
            this.subtitleValues.forEach( (subtitle, ind) => {
              const valueKey = getKeyValue(this.payload, key)
              let value = valueKey ? getValueFormatSupport(valueKey) : ''
              this.subtitleValues[ind] = subtitle?.replaceAll('${'+key+'}',value)
            })
          });
        }
        
        const parts = sub?.split(/\s+/);
        if(parts){
          const partsWithDot = parts.filter(k => k.includes(".") && !k.match(/\$\{([^}]+)\}/g));
  
          partsWithDot.forEach(part => {
            const valueKey = getKeyValue(this.payload, part)
            let value = valueKey ? getValueFormatSupport(valueKey) : ''
            this.subtitleValues[index] = this.subtitleValues[index]?.replaceAll(part, value)
          });
        }
  
      });
    }
  }

  getFinishedTasks(): void {
    this.settingsService.observeTridysIdFinishedTasksFirestore(this.data?.idToShow).then(sortedTasks => {
      this.finishedTasks = sortedTasks;
    }).catch(error => {
      console.error('Error fetching tasks:', error);
    });
  }

  openFinishedTaskInNewTab(taskId): void {

    const url = this.router.serializeUrl(
      this.router.createUrlTree(['home', this.contextId, 'tridys', this.data.idToShow, 'finishedTasks', taskId.id])
    );

    window.open(url, '_blank');
    
  }

  supportUrl(url, key){
    if(url){
      this.urlData[key]=url

      try{
      const imgUrl = new URL(url)
      let hostname = environment.urlHostName
      const isEmulator = environment.useEmulators
      
      if(imgUrl.protocol=="pass:" ){
        const parts = url.match(/pass:\/\/(.+)\/(.+)/)
        if(parts){
          const passTemplateID = parts[1]
          const path = parts[2]
          let firebaseUrl = `https://${hostname}/v1/pass/${passTemplateID}/${path}`
          if(isEmulator)
          firebaseUrl = `http://localhost:5000/v1/pass/${passTemplateID}/${path}`
          this.urlData[key]=firebaseUrl
        }else{
          const newparts = url.match(/pass:\/\/(.+)/)
          if(newparts){
            let firebaseUrl = `https://${hostname}/v1/pass/${this.data.idToShow}`
            if(isEmulator)
              firebaseUrl = `http://localhost:5000/v1/pass/${this.data.idToShow}`
            newparts.forEach( (part,index)=> {
              if(index>0){
                firebaseUrl += '/' + part 
              }
            })
            this.urlData=firebaseUrl
          }
        }
      } 

      if(imgUrl.protocol =="tridy:"){
        const parts = url.match(/tridy:\/\/(.+)\/(.+)/)
        if(parts){
          let path =""
          parts.forEach((parte, index) =>{
            if(index>0 && index<parts.length){
              path += "/" + parte
            }
          })
          let firebaseUrl = `https://${hostname}/v1/pass${path}`
          if(isEmulator)
          firebaseUrl = `http://localhost:5000/v1/pass${path}`
          this.urlData[key]=firebaseUrl
        }else{
          let path = "/" + this.data.idToShow
          const partsx = url.match(/tridy:\/\/(.+)/)

          partsx.forEach((parte, index) =>{
            if(index>0 && index<partsx.length){
              path += "/" + parte
            }
          })
          let firebaseUrl = `https://${hostname}/v1/pass${path}`
          if(isEmulator)
          firebaseUrl = `http://localhost:5000/v1/pass${path}`
          this.urlData[key]=firebaseUrl
        }
      }
      }catch(erro){}
    }
  }
  
  isObject(obj){
    return typeof obj === 'object'; 
  }

  async getContentTypes(){
    try{
      this.settingsService.observeContextsContentTypesFirestoreWithId(this.settingsService.contextId$).subscribe ( value => {
        this.allContentTypesList = value
      })
    }catch(error){
      console.log(error)
    }
  }

  getContentTypeFieldById(id, field){
    const content =  this.allContentTypesList?.find( ct => ct.id == id)
    if(content && content[field])
      return deepCopy(content[field])
  }

  getContentTypeDataById(id){
    const content =  this.allContentTypesList?.find( ct => ct.id == id)
    return deepCopy(content)
  }

  isDateTime(element){
    return isDateTime(element)
  }

  openDetailedView(tridyId?:string) {
    if (tridyId) {
        const url = this.router.serializeUrl(
        this.router.createUrlTree(['home', this.contextId, 'tridys', tridyId])
      );
      window.open(url, '_blank');
    }
    else {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['home', this.contextId, 'tridys', this.data.idToShow])
      );
      window.open(url, '_blank');
    }

  }

  showAllPayload(){
    this.showAll = !this.showAll
    if(this.payloadCard){
      this.payloadCard.classList.toggle('d-none', !(this.contentTypeData?.displaySections && this.showAll))
    }
  }

  getPayloadDataByFieldKey(key){
    if(this.allpayload){
      const value = getValueFromKey(this.payload ?? {}, key)
      // const foundKey = this.allpayload.find(payload => payload[0] == key);
      // if (foundKey) {
      //   const value = foundKey[1];
      //   if (isTimeStamp(value)) {
      //     return value.toDate().toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' }) +
      //            ', ' + value.toDate().toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
      //   }
      //   return value;
      // }
      return isTimeStamp(value) ? value.toDate().toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' }) +
        ', ' + value.toDate().toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' }) : value
    }
  }

  getTRIDYIdData(tridyId, field){
    if(this.allTridysList){
      const tridy = this.allTridysList.find( id => tridyId == id.id)
      if(tridy && tridy[field]){
        return tridy[field]
      }
    }
  }

  getTitleKeyOfTridy(data, titleKey){
    return getTitleKeyOfTridy(data, titleKey)

  }
  getSubtitleKeyOfTridy(data, subtitleKeys){
    return getSubtitleKeyOfTridy(data, subtitleKeys)
  } 

  QRoptions(){
    let contentype = this.allContentTypesList?.find( ct => ct.id == this.contentType)
    let nfcPrefix = this.getContentTypeFieldById(this.tridyData.contentType, 'nfcURLPrefix')
    let dialogRef= this.dialog.open(QrCodeDialogComponent, {
      data: {
        tridy:this.tridyData,
        id: this.data.idToShow,
        nfcPrefix: nfcPrefix ?? undefined,
        name:  contentype?.displayName ?? contentype?.name ?? this.idToShow
      }
    });
  }

  dialogCancel(data?){
    this.dialogRef.close([false]);
  }

  matchingDate(value){
    return returnDateIfStringFormatZ(value)
  }
}
